var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYaskill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0021 46.3162V60L53.9997 46.1389V32.4568L30.0021 46.3162Z",
    fill: "url(#paint0_linear_3432_151)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7445 19.8883L52.5853 13.0463L30.0021 0V13.6835L40.7445 19.8883Z",
    fill: "url(#paint1_linear_3432_151)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6754 23.9739V37.6619L30.0016 43.0476V29.3658L20.6754 23.9739Z",
    fill: "url(#paint2_linear_3432_151)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9997 15.499L30.0021 29.3658V43.0476L53.9997 29.1864V15.499Z",
    fill: "url(#paint3_linear_3432_151)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42908 13.0383L19.1989 19.9203L30.0016 13.6835V0L7.42908 13.0383Z",
    fill: "url(#paint4_linear_3432_151)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8448 39.297V22.3325L6 15.4927V46.1385L30.0016 59.9996V46.3158L17.8448 39.297Z",
    fill: "url(#paint5_linear_3432_151)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3432_151",
    x1: 42.6009,
    y1: 32.7323,
    x2: 36.4632,
    y2: 56.9637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2A808D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDEBE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3432_151",
    x1: 41.8583,
    y1: 0.198883,
    x2: 38.3713,
    y2: 18.1407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2A808D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDEBE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3432_151",
    x1: 25.5717,
    y1: 24.1647,
    x2: 18.8761,
    y2: 38.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2A808D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDEBE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3432_151",
    x1: 42.6009,
    y1: 15.7744,
    x2: 36.461,
    y2: 40.0101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2A808D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDEBE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3432_151",
    x1: 19.2797,
    y1: 0.199202,
    x2: 15.7804,
    y2: 18.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2A808D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDEBE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3432_151",
    x1: 18.6009,
    y1: 15.9378,
    x2: 3.99534,
    y2: 51.6284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2A808D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDEBE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYaskill);
export default __webpack_public_path__ + "static/media/logo_yaskill.81f82aa72d2821aabd669fcdffe7f648.svg";
export { ForwardRef as ReactComponent };